import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgIf} from "@angular/common";
import {SubscriptionPlansComponent} from "./subscription-plans/subscription-plans.component";
import {SinglePlanComponent} from "./single-plan/single-plan.component";
import {PaymentComponent} from "./payment/payment.component";
import {CancelSubscriptionModalComponent} from "./cancel-subscription-modal/cancel-subscription-modal.component";
import {SubscriptionPlanTabsEnums} from "../../../../enums/subscription-enums";
import {PaymentHttpService} from "../../../../services/http-services/payment/payment-http.service";
import {ToastrService} from "ngx-toastr";
import {AuthenticationHelperService} from "../../../../services/helpers/authentication-helper.service";
import {UserRoles} from "../../../../enums/general-enums";
import { TranslateModule } from '@ngx-translate/core';
import {FreePlan} from "../../../../constants/subscription-variables";
import {CheckActiveRolePipe} from "../../../../pipes/check-active-role/check-active-role.pipe";

@Component({
  selector: 'tl-subscription',
  standalone: true,
  imports: [
    NgIf,
    SubscriptionPlansComponent,
    SinglePlanComponent,
    PaymentComponent,
    CancelSubscriptionModalComponent,
    TranslateModule,
    CheckActiveRolePipe
  ],
  templateUrl: './subscription.component.html',
})
export class SubscriptionComponent implements OnInit {
  @Input() activeTab: string = SubscriptionPlanTabsEnums.plans;
  @Input() usedSubscriptionPlan: any;
  @Output() onChangePlanTab: EventEmitter<string> = new EventEmitter<string>();
  @Output() onPlanUpdate: EventEmitter<void> = new EventEmitter<void>();
  selectedPlan: any;
  cancelPlan: any;
  isCancelSubscriptionModalOpen = false;
  hasMobileSubscriptionActive = false;
  hasWebSubscriptionActive = false;
  protected readonly SubscriptionPlanTabsEnums = SubscriptionPlanTabsEnums;
  protected readonly UserRoles = UserRoles;

  constructor(private paymentHttpService: PaymentHttpService,
              private toastService: ToastrService,
              private authHelperService: AuthenticationHelperService) {
  }

  ngOnInit(): void {
    if (this.authHelperService.getUserData.subscriptions) {
      this.hasMobileSubscriptionActive = this.authHelperService.getUserData.subscriptions.some((element: any) => {
        return (['tlalister-mobile', 'tlexpert-mobile', 'tlpartner-mobile'].includes(element.type) && element.stripe_status === 'active');
      });
      this.hasWebSubscriptionActive = this.authHelperService.getUserData.subscriptions.some((element: any) => {
        return (['tlalister', 'tlexpert', 'tlpartner'].includes(element.type) && element.stripe_status === 'active');
      });
    }
  }

  getCurrentSubscriptionPlan(): void {
    this.paymentHttpService.getCurrentSubscriptionPlan().then((res: any) => {
      this.usedSubscriptionPlan = res.data;
    });
  }

  onConfirmCancelSubscription(): void {
    this.paymentHttpService.cancelSubscriptionPlan({plan_id: this.cancelPlan.planId}).then(res => {
      if (res.code === 200) {
        this.cancelPlan = undefined;
        this.authHelperService.setUserData(res.data);
        this.getCurrentSubscriptionPlan();
        this.isCancelSubscriptionModalOpen = false;
        this.toastService.success(res.message);
      }
    });
  }
}
